import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Global } from '@services/core/Global';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EntityBillingService {
  private http = inject(HttpClient);
  private url = Global.url + 'V1/entity-billing';

  // Obtiene cobros consolidados por entidad para el periodo
  getByPeriod(periodUuid: string): Observable<any> {
    return this.http.get<any>(`${this.url}/period/${periodUuid}`);
  }

  // Marca como contabilizado el cobro a entidades del periodo
  markAccounted(periodUuid: string): Observable<any> {
    return this.http.put<any>(`${this.url}/period/${periodUuid}/mark-accounted`, {});
  }
}
